import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import Menu from './components/fleet-menu/index.js';
import { NavigationSection } from './components/fleet-menu/navigation-section.js';
import { ROLE_ENUM } from './enums/role-enum.enum.js';
import {
  logout,
  setConfiguration,
  setFeatures,
  setSessionReady,
} from './reducer/actions.js';
import { navigationRoutes } from './routes.js';
import { RouteRenderer } from './routes-renderer.js';
import { ToastContainer } from 'react-toastify';
import OnboardingProvider from './components/onboarding/OnboardingProvider.js';

export default function App() {
  const config = useSelector((state) => state.config);
  const features = useSelector((state) => state.features);
  const sessionReady = useSelector((state) => state.sessionReady);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const hasToken = localStorage.getItem('fleetToken') != null;
  // null  = token présent mais session pas encore initialisée (pas de rendu, pas de redirect)
  // false = pas de token ou après logout (redirect /login)
  // true  = session complète, routes disponibles
  const isAuthenticated = !hasToken ? false : sessionReady ? true : null;

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('fleetToken');
    if (!token) {
      dispatch(setSessionReady());
      return;
    }

    try {
      const decoded = jwtDecode(token);
      if (decoded.user?.version !== '1.1.1') {
        logoutAction();
        return;
      }
      dispatch(
        setConfiguration({
          is_super_admin: decoded?.user?.roles?.includes(ROLE_ENUM.SUPER_ADMIN),
          is_admin:
            decoded?.user?.roles?.includes(ROLE_ENUM.ADMIN) ||
            decoded?.user?.roles?.includes(ROLE_ENUM.SUPER_ADMIN),
          logo_url: decoded?.client?.logo_url,
          client_id: decoded?.user?.client_id,
        })
      );
      dispatch(setFeatures(decoded?.client?.features ?? {}));
      dispatch(setSessionReady());
    } catch {
      logoutAction();
    }
  }, [dispatch]);

  const logoutAction = () => {
    localStorage.removeItem('fleetToken');
    localStorage.removeItem('fleetClientId');
    dispatch(logout());

    navigate('/login');
  };

  const handleMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleMenuClose = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <OnboardingProvider isAuthenticated={isAuthenticated}>
      <div className="App">
        <button
          className="App-nav-toggle"
          onClick={handleMenuToggle}
          aria-label="Toggle navigation menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <nav className={`App-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <Menu isAuthenticated={isAuthenticated}>
            {navigationRoutes
              .filter(
                (section) => section.need_authentication === isAuthenticated
              )
              .map((section) => (
                <NavigationSection
                  key={section.title}
                  title={section.title}
                  section={section}
                  routes={section.routes}
                  config={config}
                  features={features}
                  onNavigate={handleMenuClose}
                />
              ))}
          </Menu>
        </nav>
        <section className={`App-frame ${isMobileMenuOpen ? 'menu-open' : ''}`}>
          <RouteRenderer
            config={config}
            features={features}
            isAuthenticated={isAuthenticated}
          />
        </section>
      </div>
      <ToastContainer position="bottom-right" limit={1} />
    </OnboardingProvider>
  );
}
